export const QualityFeedbackType = Object.freeze({
    AUTO: 1,
    MANUAL: 2,
    SKIP: 3
});

export const RecordingEngineEnum = Object.freeze({
    Flash: 1,
    WebRtcOT: 2,
    WebRtcLocal: 3
});

export const MessageType = Object.freeze({
    command: {
        PLAY: 1,
        PRELOAD_MEDIA: 2,
        ASK_WEBCAM_ACCESS_AND_CHECK_QUALITY: 3,
        GET_SESSION_INFO: 4,
        SET_PLAYLIST: 5,
        PLAY_NEXT: 6,
        ADD_STIMULUSINFO: 7,
        TERMINATE: 8,
        START_RECORDING: 9,
        STOP_PLAYING: 10,
        ASK_WEBCAM_ACCESS: 11,
        CHECK_WEBCAM_QALITY: 12,
        STOP_RECORDING: 13,
        ADD_POSTPROCESSING_ACTION: 14,
        SHOW_PRIVACY: 15,
        SHOW_WEBCAM_PERMISSION_SCREEN: 16,
        COOKIE_CONSENT_PROVIDED: 17,
        COMPLETE: 18
    },
    feedback: {
        COMMAND_STARTED: 100,
        COMMAND_IN_PROGRESS: 101,
        COMMAND_FINISHED: 102,
        COMMAND_FAILED: 103
    }
});

export const SessionState = Object.freeze({
    new: 1,
    checking_environment: 2,
    selecting_webcam: 3,
    requesting_access_to_webcam: 4,
    checking_video_quality: 5,
    user_is_correcting_environment: 6,
    requesting_full_screen_permission: 7,
    calibrating: 8,
    processing_calibration: 9,
    preloading_media: 10,
    collecting: 11,
    processing: 12,
    collected: 13,
    declined: 14,
    fail: 15,
    processed: 16,
    processing_failed: 17,
    checking_camera_feeds: 18,
    connecting_to_media_server: 19
});

export const WebCamState = Object.freeze({
    gotIt: "gotIt",
    allowed: "allowed",
    denied: "denied",
    failed: "failed",
    autoDenied: "autoDenied",
    reAllowDisplayed: "reAllowDisplayed",
    retryRequest: "retryRequest",
    readyToUse: "readyToUse",
    startAskPermissions: "startAskPermissions",
    startQualityCheck: "startQualityCheck",
    gotItTimeout: "gotItTimeout",
});

export const ErrorReason = Object.freeze({
    face_duplication: 'face_duplication',
});

export const MouseClickTypes = Object.freeze({
    LEFT_BUTTON: 1,
    RIGHT_BUTTON: 2,
    MIDDLE_BUTTON: 3,
    VISIBLE_SKIP_BUTTON: 4,
    VISIBLE_CONTINUE_BUTTON: 5
});

export const PreloadPolicy = Object.freeze({
    STREAM: "none",
    PRELOAD_ONE: "one",
    PRELOAD_ALL: "all"
});

export const TestElementType = Object.freeze({
    IMAGE: 1,
    VIDEO: 2,
    INSTRUCTION: 3,
    REDIRECT: 4,
    LOADING: 5,
    ERROR: 6,
    BUFFERING: 7,
    PAUSE: 8,
    URL: 9,
    TEXT: 10
});

export const PreloadProgress = Object.freeze({
    started: 'started',
    finished: 'finished',
    inProgress: 'inProgress'
});

export const TestState = Object.freeze({
    started: 'started',
    finished: 'finished',
    playing: 'playing',
    finishPlaying: 'finish-playing'
});

export const ScaleMode = Object.freeze({
    SCALE: "Scale",
    FIXED: "Fixed",
    SCROLL: "Scroll"
});

export const TestElementSequenceType = Object.freeze({
    Instruction: 1,
    Video: 2,
    Image: 3,
    OrientationInstruction: 4,
});